export default class Entity {


	constructor({
		type = null
	} = {}) {
		this.type;
		this.helper;
		this.object;
	}

}